
export default class DashboardEvents {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  findByName(name, data) {
    console.log(name, data);
    return null;
  }

  counts(filter) {
    var event = DashboardEvents.Counts.Request(filter);
    return this.eventsDomain.initRequest(event);
  }

  static Counts = {
    Names: {
      Request: 'DashboardCountsRequestEvent',
      Response: 'DashboardCountsResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'Unable to get counts',
        details: '',
      },
    },

    Request: function (filter) {
      var cmd = {
        handler: DashboardEvents.Counts.Names.Request,
        eventName: DashboardEvents.Counts.Names.Request,
      }
      var params = {
        filter: filter.data,
      };
      cmd["Params"] = params;
      return cmd
    },
  }

}
